import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import moment from 'moment';
import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggestsAvailPricing';

/* Dialogs */
import AddShippingAddressOverlayDialog from '../../dialogs/addShippingAddressOverlayDialog';
import AddAccessoriesDialog from '../../dialogs/addAccessoriesDialog';
import AddServicesOverlayDialog from '../../dialogs/addServicesOverlayDialog';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';

/* Actions */
import {
    showAddressVerificationDialog,
    getOrderableServices,
    checkServicePrices,
    getPIMItemInfo,
    createNewOrder,
    saveCreatedPackageDetails,
    saveOrderableServices,
} from '../../../redux/actions';

class EditPackage extends Component {

	constructor(props) {
		super(props);
		this.state = {
            isDataValid : true,
            errorMessage: '',
            createPackageForm: {
                params: null,
                errors: {
                    poNumberError: '',
                }
            },
            showAddShippingAddressOverlayDialog: false,
            showAddAccessoriesDialog: false,
            showAddServicesOverlayDialog: false,
            showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',
            shippingAddressList: this.props.getCombinedAddresses().filter(item => item.PURPOSE === 'SHIP_TO'),
		};
        this.setChangeMethod = [];
        this.redirectToConfirmationPage = this.redirectToConfirmationPage.bind(this);
        this.checkLocTypeAvailable = this.checkLocTypeAvailable.bind(this);
        this.onChangeUpdateParam = this.onChangeUpdateParam.bind(this);
        this.handleDialog = this.handleDialog.bind(this);
        this.handleAddAccessories = this.handleAddAccessories.bind(this);
        this.handleCallBackAfterAddedNewAddress = this.handleCallBackAfterAddedNewAddress.bind(this);
        this.getShippingAddressZipCode = this.getShippingAddressZipCode.bind(this);
        this.manageAvailableServices = this.manageAvailableServices.bind(this);
        this.checkIfStateIsAk = this.checkIfStateIsAk.bind(this);
        this.getShippingAddressState = this.getShippingAddressState.bind(this);
        this.onChangeShippingAddress = this.onChangeShippingAddress.bind(this);
	}

    componentWillMount() {
		const self = this;
        let isPricingAccess = self.props.isResponsibilityExists("Price");
        const { packageDetails } = self.props.state.packages;
		// redirect user to home page if user has not access to this page
		if(!isPricingAccess || !packageDetails) {
			browserHistory.push('/home');
		}
	}

    componentDidMount() {
        const self = this;
        const { packageDetails } = self.props.state.packages;
        packageDetails.items.forEach((item) => {
            item.action = 'update';
        });
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: packageDetails
            }
        });
    }

    updateDeliveryAndLocType() {
        const self = this;
        self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, 'sds_loc', resp => {
            if(self.checkIfStateIsAk()) {
                resp = {
                    agentid: "SEA",
                    dockcity: "SEATTLE"
                }
            }
            if (resp.agentid) {
                self.setState({
                    createPackageForm: {
                        ...self.state.createPackageForm,
                        params: {
                            ...self.state.createPackageForm.params,
                            deliveryMethod: resp.loctype === 'sds_loc' ? 'SDS Delivery' : 'ADC LTL',
                            warehouseCode: resp.agentid
                        }
                    }
                }, () => {
                    if (self.state.createPackageForm.params.deliveryMethod !== 'SDS Delivery') {
                        const { items } = self.state.createPackageForm.params;
                        items.forEach(item => {
                            delete item.relatedServices;
                        });
                        self.setState({
                            createPackageForm: {
                                ...self.state.createPackageForm,
                                params: {
                                    ...self.state.createPackageForm.params,
                                    items,
                                }
                            }
                        });
                    }
                });
            }
        });
    }

    updateQuickOrderState(itemIndex, productDetails) {
		const self = this;
        const { items } = self.state.createPackageForm.params;
        items.forEach((item, index) => {
            if(index === itemIndex) {
                item.productDetails = productDetails;
                item.item = productDetails.sku;
                item.itemDescription = productDetails.description;
                let netPrice = '';
                if(productDetails.pricingData && productDetails.pricingData.length) {
                    const data = productDetails.pricingData.find(itm => itm.item_number === item.item);
                    if (data && data.records && data.records.length && data.records[0].adjusted_unit_price) {
                        netPrice = data.records[0].adjusted_unit_price;
                    }
                }
                item.price = netPrice;
				delete item.isAddressChanged;
            }
        })
        self.setState({
            createPackageForm: {
                ...this.state.createPackageForm,
                params: {
                    ...this.state.createPackageForm.params,
                    items
                }
            },
            isDataValid: true
        });
    }

    handleChangeProductNumberTextBox(itemIndex, productNumber) {
        const self = this;
        const { items } = self.state.createPackageForm.params;
        items.forEach((item, index) => {
            if(index === itemIndex) {
                item.item = productNumber;
                item.itemError = '';
                if(productNumber === '') {
                    item.productDetails = null
                }
            }
        })
        self.setState({
            createPackageForm: {
                ...this.state.createPackageForm,
                params: {
                    ...this.state.createPackageForm.params,
                    items
                }
            }
        });
    }

    // event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

    onChangeShippingAddress(event) {
        const self = this;
        const { shippingAddressList } = self.state;
        const address = shippingAddressList.find(item => item.ADDRESS1 === event.target.value);
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
    				...self.state.createPackageForm.params,
    				shippingAddress: {
                        name: self.state.createPackageForm.params.shippingAddress.name,
                        address1: address.ADDRESS1,
                        address2: "",
                        address3: "",
                        address4: "",
                        city: address.CITY,
                        state: address.STATE,
                        zip: address.POSTALCODE,
                        phone: '',
                        addressId: address.SITE_USE_ID,
                        SITEID: address.SITEID,
                    }
    			}
            }
        }, () => {
            self.updateDeliveryAndLocType();
        });
    }

    onChangeUpdateParam(event) {
        const self = this;
		let { name, value } = event.target;
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
    				...self.state.createPackageForm.params,
    				[name]: value
    			}
            }
        });
		if(self.state.createPackageForm.errors[name+"Error"]) {
			self.setState({
                createPackageForm: {
                    ...self.state.createPackageForm,
    				errors: {
    					...self.state.createPackageForm.errors,
    					[name+"Error"]: ""
    				}
                }
	        });
		}
    }

    onChangeUpdateItem(index, event) {
        const self = this;
		let { name, value } = event.target;
        const { items } = self.state.createPackageForm.params;
        items[index][name] = value;
        if (items[index][name+'Error']) {
            items[index][name+'Error'] = '';
        }
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
    				...self.state.createPackageForm.params,
    				items
    			}
            }
        });
    }

    handleRemoveAll(event) {
        event && event.preventDefault();
        const self = this;
        const { selectedPriceSource } = this.props.state.user;
		let agreementNumber = '';
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
		}
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items: [{
                        item: '',
                        itemError: '',
                        itemType: 'M',
                        quantity: "1",
                        price: '',
                        productDetails: null,
                        agreementNumber,
                        quantityError: false,
                        agreementNumberError: false
                    }]
                }
            }
        });
    }

    handleAddAccessories(accessories) {
        const self = this;
        const { items } = self.state.createPackageForm.params;
        const needToAddAccessories = [];
        accessories.forEach(item => {
            if (!items.find(itm => itm.item === item.item)) {
                needToAddAccessories.push({
                    serviceType: 'A',
                    serviceId: item.item,
    				price: item.price,
    				serviceName: item.itemDescription,
    				quantity: item.quantity,
    				extendedPrice: item.price,
                });
            }
        });
        let relatedServices = items[self.state.selectedSKUIndex].relatedServices || [];
        const existingServices = relatedServices.filter(item => item.serviceType === 'S');
        const existingAccessories = relatedServices.filter(item => item.serviceType === 'A');
        items[self.state.selectedSKUIndex].relatedServices = existingAccessories.concat(needToAddAccessories).concat(existingServices);
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
        });
    }

    handleAddNewProduct(event) {
        event.preventDefault();
        const self = this;
        const { items } = self.state.createPackageForm.params;
        const { selectedPriceSource } = this.props.state.user;
        let agreementNumber = '';
        if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
            agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
        }
        items.push({
            action: 'new',
            item: '',
            itemError: '',
            itemType: 'M',
            quantity: "1",
            price: '',
            productDetails: null,
            agreementNumber,
            quantityError: false,
            agreementNumberError: false
        });
        self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
        });
    }

    handleDelete(indx, item, event) {
		event.preventDefault();
		const self = this;
		const items = JSON.parse(JSON.stringify(self.state.createPackageForm.params.items));
		items.forEach((item, index) => {
			if(index === indx) {
                if (item.action === 'new') {
                    item.isDelete = true;
                } else {
                    item.action = 'delete';
                }
			}
		});
		self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
		});
	}

    handleDeleteServices(indx, subIndex, event) {
		event.preventDefault();
		const self = this;
		const items = JSON.parse(JSON.stringify(self.state.createPackageForm.params.items));
		items.forEach((item, index) => {
			if(index === indx) {
                item.relatedServices = item.relatedServices.filter((itm, ind) => ind !== subIndex);
			}
		});
		self.setState({
            createPackageForm: {
                ...self.state.createPackageForm,
                params: {
                    ...self.state.createPackageForm.params,
                    items
                }
            }
		});
	}

    handleCallBackAfterAddedNewAddress(data, addressCreated) {
		const self = this,
			shippingAddressList = self.state.shippingAddressList;
		if(!shippingAddressList.find(item => item.ADDRESS1 === data.address1 && item.CITY === data.city && item.STATE === data.state && item.POSTALCODE.indexOf(data.zipCode) === 0)) {
			shippingAddressList.push({
				FIRSTNAME: data.firstName,
				LASTNAME: data.lastName,
				ADDRESS1: data.address1,
				ADDRESS2: data.address2,
				ADDRESS3: data.address3,
				ADDRESS4: data.address4,
				CITY: data.city,
				COUNTY: data.county,
				STATE: data.state,
				POSTALCODE: data.zipCode,
				SITE_USE_ID: data.addressId
			});
		}

		self.setState({
			showAddShippingAddressOverlayDialog: false,
			shippingAddressList,
			createPackageForm: {
				...self.state.createPackageForm,
				params: {
					...self.state.createPackageForm.params,
					shippingAddress: JSON.stringify({
						FIRSTNAME: data.firstName,
						LASTNAME: data.lastName,
						ADDRESS1: data.address1,
						ADDRESS2: data.address2,
						ADDRESS3: data.address3,
						ADDRESS4: data.address4,
						CITY: data.city,
						COUNTY: data.county,
						STATE: data.state,
						POSTALCODE: data.zipCode,
						SITE_USE_ID: data.addressId
					})
				}
			}
		});
	}

    getElementOffset(elementId) {
		var bodyRect = document.body.getBoundingClientRect(),
			el2 = document.getElementById(elementId).getBoundingClientRect(),
			offset   = el2.top - bodyRect.top;
		return offset;
	}

    handleUpdate(event) {
        event.preventDefault();
        const self = this,
            { params, errors } = self.state.createPackageForm;
        let formError = false;

        for(var key in errors) {
            if(params[key.replace("Error","")] === "") {
                errors[key] = 'error';
                formError = true;
            } else {
				errors[key] = '';
			}
        }
        params.items.forEach((item, index) => {
			if(!item.isDelete) {
                if(!item.item) {
	                item.itemError = true;
	                formError = true;
	            }
                if(!item.quantity || item.quantity < 0) {
	                item.quantityError = true;
	                formError = true;
	            }
	            if(item.productDetails && item.productDetails.status === false) {
	                formError = true;
	            }
				if(item.productDetails && (!item.productDetails.pricingData || item.productDetails.pricingData.length === 0)) {
	                formError = true;
	            }
                if(item.relatedServices) {
    				item.relatedServices.map((itm, indx) => {
    					itm.quantityError = (itm.quantity === '' || itm.quantity === 0)?'error':''
    					if(itm.quantity === '') {
    						formError = true;
    						window.scrollTo(0, self.getElementOffset("quantity"+index));
    					}
    					return null;
    				})
    			}
				// skuList.push({sku: item.item, itemType: 'M'});
			}
        });
        self.setState({
            createPackageForm: {
    			params,
    			errors
            },
            errorMessage: '',
		}, () => {
            if(!formError) {
                const { userDetails, selectedPriceSource } = self.props.state.user;
                const items = JSON.parse(JSON.stringify(params.items)).filter((item) => !item.isDelete);
                const payload = {
                    ...params,
                    items,
                    poNumber: params.poNumber.toUpperCase(),
                    createdById: userDetails.sso,
                    createdBy: userDetails.firstName + " " + userDetails.lastName,
                    email: userDetails.email,
                    accountNumber: self.props.getSelectedAccountNumber(),
                    deliveryMethod: params.deliveryMethod,
                    agreementNumber: selectedPriceSource.AGREEMENT_NUMBER
                };
                let itemsDetails=payload.items
                let filteredItemPrice= itemsDetails.map(function(item){
                    return item['price'];
                })  

                function  getItemPrice(price)
                {                      
                    for(let i=0;i<price.length;i++)
                    {
                        if(price[i]=='')
                        {
                            return true;
                        }                
                    }
                    return false;                  
                }

                let itemPriceStatus=getItemPrice(filteredItemPrice); 

                if(itemPriceStatus==false)
              {
                self.setState({
                    updatePackageDetails: payload
                }, () => {
                    self.props.createNewOrder(payload, "requestType=updatePackageOrder", true, response => {
                        if(response.status) {
            				if(response.responseObject) {
                                self.redirectToConfirmationPage();
            				} else {
            					const updateOrderPackageErrorOccured = [];
            					const responseMessage = response.responseMessage.split(',');
            					responseMessage.forEach((error, index) => {
            						if(error) {
            							updateOrderPackageErrorOccured.push(<span className={error.indexOf('Error') === -1 ? "green" : ""} key={index + 1}>{error}<br/></span>);
            						}
            					});
            					self.setState({
            						updatePackageDetails: {
            							...self.state.updatePackageDetails,
                                        items: self.state.updatePackageDetails.items.filter(item => !item.isDelete && item.action !== 'delete'),
            							updateOrderPackageErrorOccured,
            							updateBookedOrderServiceFailed: true,
            						}
            					}, () => {
            						self.redirectToConfirmationPage();
            					});
            				}
            			} else {
            				const updateOrderPackageErrorOccured = [];
            				updateOrderPackageErrorOccured.push(response.responseMessage);
            				self.setState({
            					updatePackageDetails: {
            						...self.state.updatePackageDetails,
            						updateOrderPackageErrorOccured,
            						updateBookedOrderServiceFailed: true,
            					}
            				}, () => {
            					self.redirectToConfirmationPage();
            				});
            			}
                    });
                });
            }
            else{
                self.setState({
                    errorMessage: 'Please enter valid product'
                }); 
            }
        }   
    });
}

    redirectToConfirmationPage() {
        const self = this;
        self.props.saveCreatedPackageDetails({
            ...self.state.updatePackageDetails,
            items: self.state.updatePackageDetails.items.filter(item => !item.isDelete && item.action !== 'delete'),
        });
        browserHistory.push('package/edit/confirmation')
    }

    handleAddNewAddress(event) {
		event.preventDefault();
		this.handleDialog("AddShippingAddressOverlayDialog", true);
		this.props.showAddressVerificationDialog(false);
	}

    getShippingAddressState() {
		const self = this;
		const { createPackageForm } = self.state;
		const { shippingAddress } = createPackageForm.params;
		return shippingAddress.state;
	}

    showAddAccessories(sku, itemDescription, index, event) {
        event.preventDefault();
        this.setState({
            accessoriesSku: sku,
            selectedSKUIndex: index,
            itemDescription: itemDescription
        }, () => {
            this.handleDialog('AddAccessoriesDialog', true);
        });
    }

    getShippingAddressZipCode() {
        const self = this;
        const { createPackageForm } = self.state;
        const { shippingAddress } = createPackageForm.params;
        return shippingAddress.zip.split("-")[0];
    }

    checkIfStateIsAk() {
		const self = this;
		const { shippingAddress } = self.state.createPackageForm.params;
		let flag = false;
		if(shippingAddress && shippingAddress.state === 'AK') {
			flag = true;
		}
		return flag;
	}

    checkLocTypeAvailable(loctype) {
		const self = this;
		let shippingAddressDetail = _.find(self.props.state.user.shippingAddressDetailsListWithZipCode, {zipCode: self.getShippingAddressZipCode()});
		let data = shippingAddressDetail && _.find(shippingAddressDetail.details, ["loctype", loctype]);
		if(data && data.agentid && data.agentid !== "NA") {
			return true;
		} else {
			return false;
		}
	}

    handleAddServices(index, item, event) {
		event.preventDefault();
		const self = this;
		self.setState({
			selectedSKU: item.item,
			selectedSKUIndex: index,
            selectedSKUAccessories: (item.relatedServices || []).filter(item => item.serviceType === 'A')
		}, () => {
			const record = _.find(self.props.state.order.orderableServices, {sku: item.item});
			if(record) {
				self.manageAvailableServices(self.props.state.order.orderableServices, item.item);
			} else {
				// make service call to get warehouseCode and then make pricing service call
				self.props.getShippingAddressesDetails(self.getShippingAddressZipCode(), false, 'sds_loc', resp => {
					if(self.checkIfStateIsAk()) {
						resp = {
							agentid: "SEA",
							dockcity: "SEATTLE"
						}
					}
					if(resp && resp.agentid) {
						const itemnumbers = self.state.createPackageForm.params.items.filter(item => item.itemType === 'M' && item.item === self.state.selectedSKU).map(item => item.item);
						// Get all orderable services list
						self.props.getOrderableServices({
							OrderabilityRequest: {
								inventoryorg: resp.agentid,
								zipcode: self.getShippingAddressZipCode(),
								shipmethod: self.state.createPackageForm.params.deliveryMethod,
								itemnumbers: _.uniq(itemnumbers)
							}
						}, "requestType=getOrderableServices", response => {
							if(response.status) {
								const orderableServices = JSON.parse(JSON.stringify(response));
								const { selectedAccount, selectedPriceSource } = self.props.state.user;
								const servicesPayload = [];
								const { shippingAddress } = self.state.createPackageForm.params;
                                const { salesAgreementNumber, accountNumber } = self.props.checkForTokenAccountByMasterSA(selectedPriceSource, selectedAccount.ACCOUNTNUMBER);
								response.responseObject && response.responseObject.OrderabilityResponse.orderability.forEach(item => {
									if(item.service.length === 4 && item.service.indexOf("M") === 0) {
										servicesPayload.push({
											pricingEffectiveDate: moment().format('YYYYMMDD'),
											accountNumber,
							                state: shippingAddress.state,
											whse: resp.agentid,
							                zone: resp.sdsApZone,
											salesAgreementNumber,
											itemNumber: item.service
										});
									}
								});
                                self.setState({
									requiredPayloadForServicePricing: {
										pricingEffectiveDate: moment().format('YYYYMMDD'),
										accountNumber,
										state: shippingAddress.state,
										whse: resp.agentid,
										zone: resp.sdsApZone,
										salesAgreementNumber
									}
								}, () => {
    								if(servicesPayload.length > 0) {
    									// Get all orderable services prices list
    									self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
    										if(resp.status) {
    											// let orderableServices = self.props.state.order.orderableServices;
    											// TO DO : Temporary conversion from json string to json
    											resp.responseObject = JSON.parse(resp.responseObject);
    											const orderableServicesTemp = [];
    											orderableServices.responseObject.OrderabilityResponse.orderability.forEach(item => {
    												let record = _.find(resp.responseObject.items, {itemNumber: item.service});
    												if(record && (record.unitPrice || record.unitPrice === 0)) {
    													orderableServicesTemp.push({
    														...item,
    														servicePrice: record.unitPrice,
    														serviceDescription: item.description,
    													});
    												}
    											});
    											let finalData = [];
                                                self.state.createPackageForm.params.items.forEach(itm => {
    												if (itm.item === self.state.selectedSKU) {
    													finalData.push({
    														sku: itm.item,
    														services: _.filter(orderableServicesTemp, {itemnumber: itm.item})
    													});
    												}
    											});
    											let existingOrderableServices = self.props.state.order.orderableServices;
    											existingOrderableServices = existingOrderableServices.filter(it => it.sku !== self.state.selectedSKU);
    											existingOrderableServices = existingOrderableServices.concat(finalData);
    											self.props.saveOrderableServices(existingOrderableServices);
    											self.manageAvailableServices(finalData, self.state.selectedSKU, self.state.selectedSKUIndex);
    										} else {
    											browserHistory.push("/error");
    										}
    									})
    								} else {
    									let finalData = [];
    									self.state.createPackageForm.params.items.forEach(itm => {
    										finalData.push({
    											sku: itm.item,
    											services: []
    										})
    									})
    									self.manageAvailableServices(finalData, self.state.selectedSKU, self.state.selectedSKUIndex);
    								}
                                });
							} else {
								browserHistory.push("/error");
							}
						});
					}
				}, true, self.getShippingAddressState(), self.props.getSelectedAccountNumber());
			}
		});
	}

	manageAvailableServices(finalData, sku) {
		const self = this;
		const availableServices = _.find(finalData, {sku});
		self.setState({
			availableServices: availableServices && availableServices.services
		}, () => {
			self.handleDialog("AddServicesOverlayDialog", true, null);
		})
	}

    handleSelectedServices(serviceData, skuList, selectedSKUIndex, uncrateInd) {
		var self = this,
			items = self.state.createPackageForm.params.items;
	    items.map((item, index) => {
			if(index === selectedSKUIndex) {
                item.relatedServices = self.state.selectedSKUAccessories;
                if(skuList) {
                    skuList = skuList.filter(itm => itm.serviceType !== 'A');
                    skuList.forEach(item => {
                        item.serviceType = 'S';
                    });
                    item.relatedServices = item.relatedServices.concat(skuList);
                }
				// If user has changed uncratedInd then we have to keep it as it is.
				// else change it as per function param named uncrateInd
				// if (item.originalUncrateInd === item.uncrateInd) {
					item.uncrateInd = uncrateInd;
				// }
				// const bagItems = _.filter(item.relatedServices, {type: 'BAG'});
				// // if all related services are not of type BAG
				// if(bagItems.length !== item.relatedServices.length) {
				// 	item.uncrateInd = item.relatedServices && item.relatedServices.length > 0 ? 'Y' : 'N';
				// } else { // else all items are BAG items
				// 	item.uncrateInd = 'N';
				// }
			}
			return null;
		})
		self.setState({
			showAddServicesOverlayDialog: false,
			createPackageForm: {
				...self.state.createPackageForm,
				params: {
					...self.state.createPackageForm.params,
					items: items
				}
			}
		});
	}

    // handleShowServiceDescription(serviceDetails, event) {
	// 	event.preventDefault();
	// 	var self = this;
	// 	self.setState({
	// 		genericDialogHeading: "Service",
    //         genericDialogText: serviceDetails.serviceId + " - " + serviceDetails.serviceName,
    //         modalButtons: 'ok'
	// 	}, () => {
	// 		self.handleDialog("GenericOverlayDialog", true);
	// 	});
	// }

    handleChangeQuantityService(index, serviceId, event) {
		const self = this;
		let items = self.state.createPackageForm.params.items;
		let value = event.target.value;
		value = value === "0" ? 1 : value;
		items.forEach((item, indx) => {
			if(index === indx) {
				item.relatedServices.forEach((itm, ind) => {
					if(itm.serviceId === serviceId) {
						itm.quantity = value
						itm.quantityError = value === ''?'error':''
					}
				})
			}
		});
		self.setState({
			createPackageForm: {
				...self.state.createPackageForm,
				params: {
					...self.state.createPackageForm.params,
					items
				}
			}
		});
	}

    render() {
        const self = this;
        const {
            createPackageForm: {
                params,
                // errors
            },
            errorMessage
        } = self.state;
        if (!params) return null;
        const {
            items,
            agreementName,
            poNumber,
            shippingAddress,
        } = params;
        return (
            <div>
                <h1 className="pageTitle">Edit PACKAGE</h1>
                <p className="red bold">{errorMessage}</p>
                <form name="packagecreateform" onSubmit={this.handleUpdate.bind(this)}>
                    <div className="fullCell">
                        <p>You are creating a package for: &nbsp; <span className="bold">{agreementName}</span></p>
                    </div>
                    <div className="fullCell">
                        <table id="shipAddressTbl">
                            <tbody>
                                <tr>
                                    <td>
                                        <span style={{fontWeight: 'bold', fontSize: '14px'}}>Package Name:</span>
                                    </td>
                                    <td colSpan={2}>
                                        <input maxLength={50} onChange={this.onChangeUpdateParam.bind(this)} type="text" name="poNumber" size={50} value={poNumber} /> &nbsp;  maximum 50 characters
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <span style={{fontWeight: 'bold', fontSize: '14px'}}>Shipping Address: </span> &nbsp;
                                    </td>
                                    {shippingAddress && <td style={{paddingTop: '17px'}}>
                                        {shippingAddress && <p className="shippingAddress">
                                        {shippingAddress.address1 && shippingAddress.address1.trim()}
                                        {shippingAddress.address1 && shippingAddress.address1.trim() !== ""?<br/>:null}
                                        {shippingAddress.address2 && shippingAddress.address2.trim()}
                                        {shippingAddress.address2 && shippingAddress.address2.trim() !== ""?<br/>:null}
                                        {shippingAddress.city && `${shippingAddress.city.trim()},`} {shippingAddress.state && shippingAddress.state.trim()} {shippingAddress.zip && shippingAddress.zip.trim()}
                                        </p>}
                                    </td>}
                                    <td>
                                        Services available will be determined by this address
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <table id="createTable" className="dataTableType2 createOrderTableB milktoast2" style={{width: '100%'}}>
                        <thead>
                            <tr>
                                <th>Remove<br />All</th>
                                <th>Product</th>
                                <th>Description</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th />
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => {
                                if (item.isDelete || item.action === 'delete') return null;
                                return [<tr key={index}>
                                    <td style={{width: '5%'}}>
                                        <a href="" onClick={this.handleDelete.bind(this, index, item)} style={{textDecoration: 'none'}}>X</a>
                                    </td>
                                    {(item.action === 'update' || item.itemType === 'A' || (
                                        item.action === 'new' && item.productDetails && item.productDetails.status &&
                                        item.productDetails.pricingData && item.productDetails.pricingData.length > 0
                                    ))
                                        ? <td style={{width: '25%'}}>{item.item}</td>
                                        : <td
                                            style={{width: '25%'}}
                                            className={(
                                                (item.productDetails && item.productDetails.status === false) ||
                                                (item.productDetails &&
                                                    (!item.productDetails.pricingData || item.productDetails.pricingData.length === 0)
                                                ) ||
                                                item.itemError
                                            )?"error":""}>
                                            <AccountNumberAutoSuggests
                                               checkAvailabilityAndOrderability={this.props.checkAvailabilityAndOrderability}
                                               selectedAddressParams={null}
                                               getShippingAddressesDetails={this.props.getShippingAddressesDetails}
                                               value={item.item}
                                               setChangeMethod={(method, input) => this.setChangeMethod[index] = {method, input} }
                                               selectedPriceSource={item.agreementNumber}
                                               updateQuickOrderState={this.updateQuickOrderState.bind(this)}
                                               onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
                                               itemIndex={index}
                                               zipCode={this.props.getZipCode()}
                                               legacyCustCode={this.props.getLegacyCustCode()}
                                               itemType={item.itemType}
                                               isImportedFromFile={false}
                                               isAddressChanged={item.isAddressChanged}
                                               width='auto'
                                               getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
                                           />
                                           {(item.productDetails && item.productDetails.status === false) || (item.productDetails)
                                               ?<span className="quickOrderTableRowError">You must enter a valid full or partial product number.</span>
                                               :null
                                           }
                                       </td>
                                    }
                                    <td style={{width: '25%'}}>
                                        <p>
                                            {item.itemDescription}
                                        </p>
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <p>{self.props.formatMoney(item.price, 0, ".", ",", false, "$")}</p>
                                    </td>
                                    <td style={{width: '5%'}}>
                                        <div>
                                            <input className={item.quantityError?"error":""} style={{textAlign: 'center'}} type="text" name="quantity" size={3} onChange={this.onChangeUpdateItem.bind(this, index)} value={item.quantity} />
                                        </div>
                                    </td>
                                    <td style={{width: '20%'}}>
                                        {item.itemType === 'M' && (
                                            item.action === 'update' || (item.action === 'new' && item.productDetails && item.productDetails.status)
                                        ) && <p className="addAccessories">
                                            <a href="" onClick={this.showAddAccessories.bind(this, item.item, item.productDetails && item.productDetails.description, index)} >+&nbsp;Accessories</a>
                                        </p>}
                                    </td>
                                    <td style={{width: '15%'}}>
                                        {params.deliveryMethod === 'SDS Delivery' && item.itemType === 'M' &&
                                            (item.action === 'update' || (item.action === 'new' && item.productDetails && item.productDetails.status)) &&
                                            <p>
                                                <a onClick={this.handleAddServices.bind(this, index, item)} href="">
                                                    + Add Services
                                                </a>
                                            </p>
                                        }
                                    </td>
                                </tr>,
                                item.relatedServices?
                                    item.relatedServices.map((itm, ind) => {
                                        if(itm.type === "BAG") return null;
                                        return <tr key={ind}>
                                            <td style={{width: '5%'}}>
                                                <a href="" onClick={this.handleDeleteServices.bind(this, index, ind)} style={{textDecoration: 'none'}}>X</a>
                                            </td>
                                            <td style={{width: '25%'}}>
                                                &nbsp; &nbsp; {itm.serviceId}
                                            </td>
                                            <td style={{width: '25%'}}>{itm.serviceName}</td>
                                            <td style={{width: '5%'}}>{this.props.formatMoney(itm.price, 0, ".", ",", false, "$")}</td>
                                            <td style={{width: '5%'}}>
                                                <input
                                                    type="text"
                                                    id={"servicequantity"+ind}
                                                    className={`itemQuantity ${itm.quantityError}`}
                                                    onKeyPress={this.props.acceptNumbersOnly}
                                                    onPaste={this.props.doNothing}
                                                    value={itm.quantity}
                                                    onChange={this.handleChangeQuantityService.bind(this, index, itm.serviceId)}
                                                    defaultValue={item.quantity}
                                                    size={1}
                                                />
                                            </td>
                                            <td style={{width: '20%'}} />
                                            <td style={{width: '15%'}} />
                                        </tr>
                                    }):
                                null
                            ]})}
                        </tbody>
                    </table>
                    <br />
                    <div id="createpckbtn">
                        <p className="floatLeft addNewPageParagraph">
                            <a className="bold noUnderline uppercase" href="" onClick={this.handleAddNewProduct.bind(this)}>+ ADD ANOTHER PRODUCT</a>
                        </p>
                        <p className="floatRight">
                            <input type="submit" className="blueButton" value="UPDATE PACKAGE" />
                        </p>
                    </div>
                </form>
                {this.state.showAddShippingAddressOverlayDialog?<AddShippingAddressOverlayDialog showOtherFieldsInAddShippingAddress={this.props.showOtherFieldsInAddShippingAddress} handleDialog={this.handleDialog} existingAddresses={this.state.shippingAddressList} handleCallBackAfterAddedNewAddress={this.handleCallBackAfterAddedNewAddress.bind(this)} showDialog={true} />:null }
                {this.state.showAddAccessoriesDialog
		            ? <AddAccessoriesDialog
						checkAvailabilityGeneric={this.props.checkAvailabilityGeneric}
						getShippingAddressesDetails={this.props.getShippingAddressesDetails}
						makeParallelCallsForCartPrices={this.props.makeParallelCallsForCartPrices}
						accessoriesSku={this.state.accessoriesSku}
                        handleAddAccessories={this.handleAddAccessories}
						itemDescription={this.state.itemDescription}
						handleDialog={this.handleDialog.bind(this)}
						showDialog={true}
						getZipCode={this.props.getZipCode}
						getLegacyCustCode={this.props.getLegacyCustCode}
						getLocalStorageVar={this.props.getLocalStorageVar}
						manipulateProductSpecsData={this.props.manipulateProductSpecsData}
						isPricingAccess={this.props.isResponsibilityExists("Price")}
						fireGTMTag={this.props.fireGTMTag}
						formatMoney={this.props.formatMoney}
						getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
					/>
		            : null
		        }
                {this.state.showAddServicesOverlayDialog && this.state.availableServices?
					<AddServicesOverlayDialog
						availableServices={this.state.availableServices}
						resetSelectedSKU={this.resetSelectedSKU}
						handleSelectedServices={this.handleSelectedServices.bind(this)}
						handleDialog={this.handleDialog}
						itemLevelDisableUncrateDropdown={false}
						selectedSKU={this.state.selectedSKU}
						selectedSKUIndex={this.state.selectedSKUIndex}
						formatAmount2Decimal={this.props.formatAmount2Decimal}
						items={this.state.createPackageForm.params.items}
						getPIMItemInfo={this.props.getPIMItemInfo}
						showDialog={true}
                        requiredPayloadForServicePricing={this.state.requiredPayloadForServicePricing}
					/>
				:null }
                {this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
    showAddressVerificationDialog: (flag) => dispatch(showAddressVerificationDialog(flag)),
    saveCreatedPackageDetails: (data) => dispatch(saveCreatedPackageDetails(data)),
    getOrderableServices: (payload, params, response) => dispatch(getOrderableServices(payload, params,response)),
    checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
    getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
    saveOrderableServices: (data) => dispatch(saveOrderableServices(data)),
    createNewOrder: (payload, params, useBootApi, response) => dispatch(createNewOrder(payload, params, useBootApi, response)),
});

EditPackage = connect(mapStateToProps, mapDispatchToProps)(EditPackage);
export default EditPackage;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Packages/editPackage.js